import React, { FunctionComponent, useState } from 'react';

import Button from '../../../UI/Button';
import Icon from '../../../Icons';
import Modal from '../../../UI/Modal';
import DatePick from '../../../UI/Date';
import { modifyTransactionDate } from '../../helper';
import UrlConfig from '../../../../utils/urlHelper';
import { downloadTransactions } from '../../download';

import { ModalTitle, ButtonList, DoubleIconButton } from '../Transactions/styles';
import { sendEvent2 } from '../../../../utils/tracking';

interface Url {
  downloadAllTransactions: Function;
}

const urlHelper: Url = UrlConfig;

const SubHeader: FunctionComponent<{ searchText?: string }> = ({ searchText }) => {
  const [dates, setDates] = useState({});
  const [error, setError] = useState('');
  const [txnType, setTxnType] = useState('');
  const [downloadModalState, setDownloadModalState] = useState(false);

  const toggleDownloadModal = () => {
    sendEvent2(
      !downloadModalState ? 'pop_up_view' : 'close_btn',
      {
        event_action: !downloadModalState ? 'view' : 'click',
        event_category: 'download_all_ft_report_pop_up',
        screen_name: 'ft_vehicle_txn_details',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    setDownloadModalState((prevState) => !prevState);
  };

  const closeDownloadModal = () => {
    sendEvent2(
      'close_btn',
      {
        event_action: 'click',
        event_category: 'download_all_ft_report_pop_up',
        screen_name: 'ft_vehicle_txn_details',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    setDownloadModalState(false);
  };

  const downloadReport = (reportFormat: 'xlsx' | 'pdf') => {
    console.log('date', dates);
    if (error) return;
    const { startDate = '', endDate = '' } = dates as any;
    downloadTransactions(
      {
        fromTime: startDate,
        toTime: endDate,
        reportFormat: reportFormat,
        ...(txnType !== '' && { txnType }),
      },
      urlHelper.downloadAllTransactions,
    );
    if (startDate !== '' && endDate !== '') {
      const diff = endDate - startDate;
      sendEvent2(
        reportFormat === 'xlsx' ? 'download_excel_btn' : 'download_pdf_btn',
        {
          event_action: 'click',
          event_category: 'download_all_ft_report_pop_up',
          screen_name: 'ft_vehicle_txn_details',
          miscellaneous: JSON.stringify({
            type: txnType === '' ? 'All' : txnType,
            duration: diff,
          }),
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
    }
    closeDownloadModal();
  };

  const validateDate = (label: string, value: Date) => {
    const dateObj = modifyTransactionDate(label, value, dates, true);
    setDates(dateObj);
    const { startDate, endDate } = dateObj;
    if (startDate && endDate) {
      const diff = endDate - startDate;
      const diffDays = diff / (60 * 60 * 24);
      if (diff < 0) {
        setError('Start Date cannot be greater than End Date');
      } else {
        setError('');
        if (Math.floor(diffDays) > 14) setError('Please select a date range of not more than 14 days');
      }
    }
  };

  const updateTransactionType = (e: any) => {
    setTxnType(e.target.value);
  };

  return (
    <div className="main-nav-list">
      <Button
        variant="outlined"
        icon="download"
        clickHandler={() => {
          sendEvent2(
            'download_all_ft_report_btn',
            {
              event_action: 'click',
              event_category: 'top_nav',
              screen_name: 'ft_vehicle_txn_details',
              target_product: 'fastag',
              event_platform: 'web',
            },
            true,
          );
          toggleDownloadModal();
        }}
      >
        All Fastag Report
      </Button>

      {downloadModalState && (
        <Modal isOpen={downloadModalState} onClose={closeDownloadModal}>
          <div className="flex flex-dir-c falign-s">
            <ModalTitle>Download Fastag Report of all vehicles.</ModalTitle>
            <div>
              <ModalTitle>Transaction Type</ModalTitle>
              <div className="flex mb30">
                <div>
                  <input type="radio" name="txn" value="" onChange={updateTransactionType} /> All
                </div>
                <div className="pl16">
                  <input type="radio" name="txn" value="DEBIT" onChange={updateTransactionType} /> Debit
                </div>
                <div className="pl16">
                  <input type="radio" name="txn" value="CREDIT" onChange={updateTransactionType} /> Credit
                </div>
              </div>
            </div>
            <ModalTitle>Select Date Range</ModalTitle>

            <div className="flex flex-dir-r">
              <div className="flex relative">
                <div className="mr16 relative">
                  <DatePick
                    name="startDate"
                    timePicker={true}
                    placeholder="Start Date"
                    value={null}
                    changeHandler={(val: Date) => validateDate('startDate', val)}
                  />
                </div>
                <div className="relative">
                  <DatePick
                    name="endDate"
                    timePicker={true}
                    placeholder="End Date"
                    value={null}
                    changeHandler={(val: Date) => validateDate('endDate', val)}
                  />
                </div>
              </div>
            </div>
            <p className={`smaller error ${error ? '' : 'hide'}`}>{error}</p>
            <div className="mb16"></div>
            <ModalTitle>Click to Download</ModalTitle>
            <ButtonList>
              <DoubleIconButton onClick={() => downloadReport('xlsx')}>
                <div className="left">
                  <Icon name="xls" />
                  Excel Format
                </div>
                <div className="right">
                  <Icon name="download-blue" />
                </div>
              </DoubleIconButton>
              <DoubleIconButton onClick={() => downloadReport('pdf')}>
                <div className="left">
                  <Icon name="pdf" />
                  PDF Format
                </div>
                <div className="right">
                  <Icon name="download-blue" />
                </div>
              </DoubleIconButton>
            </ButtonList>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SubHeader;
